/**
     * Obtiene el tamaño de grilla que tendrá el campo
     * @param {*} x 
     * @returns 
     */
const getGridSize = (x) => {
    const defaultGridSize = { xs: 12, md: 3, lg: 3, xl: 3 };
    if (x.grid) {
        const { xs, md, lg, xl } = defaultGridSize;
        return {
            xs: x.grid?.xs ?? xs,
            md: x.grid?.md ?? md,
            lg: x.grid?.lg ?? lg,
            xl: x.grid?.xl ?? xl
        }
    }
    return defaultGridSize;
}

/**
 * Obtiene el padding que tendrá el campo
 * @param {*} x 
 * @returns 
 */
const getPadding = (x,type) => {
    const defaultPaddingCampo = { pl: 1, pr: 1, pb: 1, pt: type === 'button' ? 4 : 2 };
    if (x.grid) {
        const { pl, pr, pt, pb } = defaultPaddingCampo;
        return {
            pl: x.padding?.pl ?? pl,
            pr: x.padding?.pr ?? pr,
            pt: x.padding?.pt ?? pt,
            pb: x.padding?.pb ?? pb
        }
    }
    return defaultPaddingCampo;
}


const dinamicFormHelpers = {
    getGridSize: getGridSize,
    getPadding: getPadding
}

export default dinamicFormHelpers;
